export default __webpack_public_path__ + "73ac1b8c2a0c727554b1c12746a38962.svg";